// Wire and domain shapes for the `dictation/preferences` family
// (ARCFE-1043 · C).
//
// Carved VERBATIM out of `src/features/dictationLogs/types.ts`, which the P0
// census mis-zoned: that module matches only the generator's `U` directory
// rule, so a purely inert contracts module was routed to `/ui` and then
// deferred with the rest of the UI. Recorded as census defect (1) on the lane.
//
// The carve line is the family line, and it is what makes this half movable:
// `types.ts` had exactly ONE app-boundary import — `DictationPercentileBand`
// re-exported from `@/lib/SessionRecordingProvider/t11nClient` — consumed only
// by `DictationStats`, which belongs to `dictation/logs`. Split on the family
// line and this half has ZERO app-boundary imports, which is why it can land
// today while its logs sibling waits on the t11nClient split.

/** Post-processing tones, in display order. `formal` is the product default. */
export const DICTATION_TONES = ['formal', 'conversational', 'casual'] as const;
export type DictationTone = (typeof DICTATION_TONES)[number];

/**
 * Raw wire shape. `tone` is an arbitrary `string` here because the server may
 * send a value outside the `DictationTone` union (or omit it); normalization
 * to `DictationTone` happens in the query's `select` via `normalizeTone`.
 */
export type DictationAppCategoryResponse = {
  id: string;
  name: string;
  /** Admin/desktop-client concern; unused on the Tone screen. */
  app_identifiers: string[];
  /** Per-category default tone (drives the "Default" badge). */
  default_tone: string;
  /** Resolved tone: the user's override, or `default_tone`. */
  tone: string;
};

export type DictationAppCategoriesResponse = {
  categories: DictationAppCategoryResponse[];
};

/** Bare ISO 639-1 base codes supported for verbal-command recognition. */
export type VerbalCommandsLanguagesResponse = {
  languages: string[];
};

/** Normalized domain shape consumed by the UI — `tone` is a valid union value. */
export type DictationAppCategory = {
  id: string;
  name: string;
  app_identifiers: string[];
  default_tone: DictationTone;
  tone: DictationTone;
};
